import VueI18n from "vue-i18n";
import {enTexts} from "./en";
import {itTexts} from "./it";

const messages = {
  en: enTexts,
  it: itTexts
};

export class LanguageManager {

  i18n: VueI18n;

  static instance: LanguageManager;

  constructor() {
    this.i18n = new VueI18n({
      locale: "it",
      messages,
    });
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/languages/languages.ts